import { isEmpty, isIPad, isIPhone, isSafari, normalizeSocialPhone } from '@/common/utils/Util';
import store from '@/store';
import router from '@/router';
export * as nativeRequest from '@/common/utils/module/NativeRequest';
export * from '@/common/utils/module/NativeRequest';
import { nativeFinish, nativeFirstRun, nativeGpsSetting, nativeClearCache, nativeSnsLogin } from '@/common/utils/module/NativeRequest';
import {
  consumeSocialJoinBlock,
  showSocialJoinBlockedModal
} from '@/common/utils/module/SocialJoinBlock';
import ServiceExec from '@/common/utils/ServiceExec';
import { modalList, show, showTextModal } from '@/common/utils/ModalState';
import { common } from '@/common/service/apiList';
import ConstCode, { BOTTOM_SHEET, MODAL_TYPE } from '@/common/constants/ConstCode';
import Update from '@/components/common/layouts/Update.vue';
import VersionUpdate from '@/components/common/layouts/VersionUpdate.vue';
import { computed } from 'vue';

/**
 * 앱 종료
 * @return ''
 * @class Util
 */

/**
 * 디바이스 정보 가져오기
 * @param deviceType
 * @param deviceId
 * @param pushToken
 * @param appVersion
 * @param os
 * @returns {Promise<void>}
 */
window.nativeSetDeviceInfo = (deviceType, deviceId, pushToken, appVersion, os) => {
  let deviceInfo = {
    deviceNo: null,
    userNo: null,
    deviceType: '',
    deviceId: '',
    pushToken: '',
    appVersion: '',
    os: ''
  };

  /* NOTICE: deviceType 1: 안드로이드, 2: IOS
      (IOS 에서 초기에는 'IOS'로 넘어오지만, 이후 '2'로 넘어오기 때문에 'IOS'로 변경)
   */
  console.log('OS', deviceInfo);
  deviceType = deviceType == 1 || deviceType === 'ANDROID' || !deviceId.includes('-') ? 'ANDROID' : 'IOS';
  let currentOS = 'ANDROID';
  if (isIPhone() || isIPad()) {
    currentOS = 'IOS';
  }
  deviceInfo['deviceType'] = deviceType;
  deviceInfo['deviceId'] = deviceId;
  deviceInfo['pushToken'] = pushToken;
  deviceInfo['appVersion'] = appVersion;
  deviceInfo['os'] = currentOS;
  store.commit('user/setDeviceInfo', deviceInfo);
  console.log('디바이스 정보:', deviceInfo);
  nativeFirstRun('nativeFirstInfo');
};

/**
 * 260812 부팅 마무리 이동 — **딥링크로 들어온 경우엔 /main으로 덮지 않는다.**
 *
 * 스토어에서 갓 설치한 신규 사용자가 QR 딥링크를 타고 들어오면, 접근권한 모달의 확인 콜백이
 * 무조건 router.replace('/main')을 해서 딥링크 목적지(/more/qr-genuine?code=…)를 덮어썼다.
 * 하필 '설치 직후 첫 실행'에서만 나는 증상이라 — 그게 정확히 QR 유입의 주 시나리오다 —
 * 기존 사용자로 테스트하면 재현되지 않는다.
 *
 * 두 순서를 모두 막는다:
 *   ① 딥링크가 아직 대기 중(initMovePath) → 곧 App.vue watch가 그리로 보낸다. 여기서 손대지 않는다.
 *   ② 딥링크가 이미 우리를 데려갔다(현재 경로가 홈이 아니다) → 덮지 않는다.
 *      App.vue watch가 소비하면서 initMovePath를 비우므로 ①만으로는 못 잡는다.
 */
const goHomeUnlessDeepLinked = async query => {
  if (store.getters['layout/initMovePath']) return;
  // 260826: 앱 홈 = 소개 페이지(/intro). 대표 "이 메인을 없애 버리잖아"(260825 17:42).
  const cur = router.currentRoute?.value?.path || '/';
  if (cur !== '/' && cur !== '/main' && cur !== '/intro') return;
  await router.replace(query ? { path: '/intro', query } : { path: '/intro' });
};

/**
 * 처음실행시 접근권한 띄움
 * @param val
 * @returns {Promise<void>}
 */
window.nativeFirstInfo = async val => {
  const deviceInfo = store.getters['user/getDeviceInfo'];
  const result = await store.dispatch('user/versionCheck', deviceInfo);

  if (result.hasUpdate && result.isForce) {
    await show(Update, {});
  } else {
    if (val === 0 || val === '0') {
      setTimeout(() => {
        const data = {
          fnCallBack: async () => {
            store.commit('user/setFirstLogin', true);
            await goHomeUnlessDeepLinked();
          }
        };
        show(modalList.AUTHORITY, data);
      }, 1500);
    } else {
      await store.commit('layout/setIsIntroEnter', true);
      await goHomeUnlessDeepLinked({ isRoot: 1 });
    }

    if (result.hasUpdate) {
      await show(VersionUpdate, {});
    }
  }
  nativeClearCache();
};

/** 푸시로 인한 router 이동 **/
window.fnRouterPush = async callbackParams => {
  await store.commit('layout/setInitMovePath', callbackParams);
};
window.fnBack = async () => {
  // 결제 화면에서 뒤로가기 할때 (안드로이드)
  // 0. modalAlert이 있는지
  // 1. modal이 있는지
  // 2. side-bar 열려 있는지
  // 3. 종료해야할 페이지인지
  // 4. router.go(-1)
  // 260915: 페이지 안에서 직접 띄운 Teleport 오버레이(홈 광고 영상 풀스크린)는 store 모달이 아니라 여기서 안 보인다 →
  //   페이지가 window.fnBackInPage 를 등록해 두면 가장 위에 뜬 그것부터 닫고 끝낸다(아니면 이탈/앱 종료로 빠짐, 유저 신고).
  //   훅이 false 를 돌려주면(열린 게 없음) 기존 순서 그대로.
  if (typeof window.fnBackInPage === 'function' && window.fnBackInPage() === true) return;
  const isFormDirty = store.getters['layout/getFormDirty'];
  const bottomSheet = store.getters['layout/getBottomSheet'];
  const modalAlerts = store.getters['layout/getModalAlertComponents'];
  const modals = store.getters['layout/getModalComponents'];

  if (modals[0]?.component.__name === 'BusinessSearchModal') {
    store.commit('layout/setIsNav', true);
  }

  // 260522 3rd-fix: BUSINESS_SEARCH 모드의 무조건 wipe + 강제 /main push 제거.
  // 이전 동작은 detail 페이지에서 네이티브 백버튼 누를 때도 검색 state를 wipe하고
  // categorySearchFlag면 /main으로 강제 이동시켜 "검색→detail→뒤로가기 후 검색 결과 안 보임"
  // "카테고리 클릭 후 뒤로가기 홈으로 빠짐" 재발을 일으켰음.
  // 변경 후엔 /business 페이지 자체에서 BUSINESS_SEARCH 모드일 때만 모드 토글을 수행하고
  // (history entry는 그대로 두어 다음 백버튼이 정상 go(-1)),
  // 다른 경로(/business/:businessNo 등)에서는 일반 router.go(-1)로 빠진다.
  const currentPath = router.currentRoute.value.path;
  if (currentPath === '/business' && bottomSheet === BOTTOM_SHEET.BUSINESS_SEARCH) {
    store.commit('business/setCategorySearchFlag', false);
    store.commit('business/setOverseasFilter', false);
    store.commit('layout/setBottomSheet', BOTTOM_SHEET.BUSINESS);
    store.commit('business/initBusinessList');
    store.commit('business/searchText');
    store.commit('business/markerPin');
    const cond = store.getters['business/getCondition'] || {};
    cond.isJob = false;
    cond.businessCategoryNo = '';
    store.commit('business/condition', cond);
    // 260527: isDonation/isEvent/isJob는 BE EXISTS 진짜 AND 필터라 셋 다 true면 거의 0건.
    //          BUSINESS 모드 복귀 시 일반 리스트가 비어 보이고, pageInfo.totalPage=0 오염으로
    //          다음 카테고리 검색의 page=1 가드를 오발동시킴. 정상 BUSINESS fetch(index.vue)와 동일하게 필터 제거.
    await store.dispatch('business/getBusinessList', { isOneKM: true });
    store.commit('business/coordinateChange', true);
    return;
  }

  const isShowSideBar = store.getters['layout/getIsShowSideBar'];
  if (!isEmpty(modalAlerts)) {
    await store.dispatch('layout/closeModalAlertComponent', {
      index: modalAlerts.length - 1
    });
    return;
  }
  if (!isEmpty(modals)) {
    await store.dispatch('layout/closeModalComponent', {
      index: modals.length - 1
    });
    return;
  }
  if (isShowSideBar) {
    await store.dispatch('layout/updateIsShowSideBar', {
      isShowSideBar: false
    });
    return;
  }

  const routePath = router.currentRoute.value.path;
  const getModalComponent = computed(() => store.getters['layout/getModalComponents']);

  if (
    (!routePath.includes('/more') &&
      (routePath.includes('/form/information') && isFormDirty ||
        routePath.includes('/welldying/form') && isFormDirty ||
        routePath.includes('/funeral/form') ||
        routePath.includes('/announcement/form') && isFormDirty)) ||
    routePath.includes('/smile/event/form/info') && isFormDirty ||
    routePath.includes('/smile/invitation/form/info') && isFormDirty
  ) {
    show(modalList.CONFIRM, {
      contents: '정말 이동하시겠습니까? \n 완료 전 작성된 내용은 저장되지 않습니다.',
      doneText: '이동하기',
      cancelText: '취소',
      doneCallback: () => {
        if (!isEmpty(getModalComponent.value)) {
          store.dispatch('layout/removeAllModalComponent');
          store.commit('memorial/initAllStep');
          store.commit('smile/initForm');
          store.commit('invitation/initForm');
        }
        store.commit('welldying/setDetail', {})
        router.go(-1);
        // proxy.$store.commit('layout/resetRouteLayout');
      }
    });
    return;
  }

  // 260428: 배터리·설정(charge-hub)에서 시스템 백버튼은 간판 선택 페이지로
  // (select → ChargeHub 진입이 router.replace라 history에 select가 없어 go(-1)이 메인으로 빠짐)
  if (router.currentRoute.value.name === 'signboard-charge-hub') {
    router.replace({ path: '/business/signboard/select', query: { target: 'charge' } });
    return;
  }

  if (!isEmpty(window.routeQuery.isRoot) && Number(window.routeQuery.isRoot) > 0) {
    nativeFinish();
    return;
  }
  router.go(-1);
};
window.setEncryptValue = async (value, value2) => {
  // juminCount 먼저
  if (!isEmpty(value2)) {
    await store.dispatch('car/updateJuminCount', {
      juminCount: Number(value2)
    });
  }
  await store.dispatch('car/updateCarInsureDTOEncryptedJumin', {
    encryptedJumin: value
  });
};
window.setNativeLocation = async (code, latitude = -1, longitude = -1) => {
  console.log('code {}, latitude {}, longitude {}', code, latitude, longitude);
  const isModal = store.getters['business/getIsLocationModal'];
  if (Number(code) === 1) {
    const position = {
      latitude,
      longitude,
      isOneKM: true
    };
    console.log('위치 정보 가져오기');
    store.commit('business/coordinate', position);
    // 260618: GPS 실좌표 별도 보관 (유령기업 카카오는 대표주소 덮어쓰기와 무관하게 이 좌표 사용)
    store.commit('business/gpsCoordinate', position);
    store.commit('business/coordinateChange', true);
  } else {
    if (isModal && !isIPhone() && !isSafari() && !isIPad()) {
      show(modalList.CONFIRM, {
        contents: '위치 허용 후 이용 가능합니다.',
        cancelText: '취소',
        doneText: '확인',
        doneCallback: () => {
          nativeGpsSetting();
        }
      });
    }
    store.commit('business/isLocationModal');
  }
};

// NOTICE: SNS 로그인 콜백 받은 후 로직
window.loginForSnsCallback = async (json = '') => {
  const container = JSON.parse(json);
  console.log('로그인 콜백', container);
  // 260807: 성공은 loginSuccessCall이 보내는 code 1 뿐이고 나머지는 전부 실패다.
  //   예전엔 code==0 / 'cancel' 만 걸러내고 그 외(네이버 오류코드 등)는 그대로 흘려보내
  //   빈 id로 signIn → 실패 → 빈 가입 화면까지 들어갔다.
  //   게다가 앱 카카오는 취소든 진짜 오류든 전부 "0"으로 보내서 모든 실패가 조용히 삼켜졌다 —
  //   260807 카카오 키 해시 불일치를 찾는 데 오래 걸린 직접적 원인이다("깜빡이고 무반응").
  //   ⚠️ Android는 code를 숫자 1로, iOS는 문자열 "1"로 보낸다 — 엄격 비교하면 iOS가 통째로 깨진다.
  if (Number(container.code) !== 1) {
    await store.dispatch('layout/removeAllModalComponent');
    // 취소는 조용히 넘어간다. "0"은 구버전 앱이 취소에 쓰던 값이라 계속 취소로 본다
    //   (안 그러면 구버전 사용자가 취소할 때마다 없던 오류 모달이 뜬다).
    const isCancel =
      container.code == 0 ||
      (typeof container.code === 'string' && container.code.includes('cancel'));
    if (!isCancel) {
      showTextModal(
        container.message || '소셜 로그인에 실패했습니다. 잠시 후 다시 시도해 주세요.',
        '확인'
      );
    }
    return;
  }

  const userData = {
    name: container.name,
    email: container.email,
    userId: container.id,
    joinType: store.getters['user/getJoinType'],
    // 260807: 앱 카카오는 kakaoAccount.phoneNumber('+82 10-1234-5678')를 그대로 넘겨주는데
    //   removeHyphen은 하이픈만 떼서 '+82 1012345678'이 남아 가입폼 검증을 통과 못 했다.
    phone: normalizeSocialPhone(container.phone),
    // 260807: 네이티브가 넘겨준 provider access_token. 이게 있어야 SignUp의 canSkipPhoneStep이
    //   통과해 전화번호 인증 화면을 건너뛴다(실제 확인은 BE가 이 토큰으로 provider에 직접 되물음).
    //   구버전 앱은 이 필드가 없어 undefined → 기존대로 SMS 인증을 거친다(하위호환).
    accessToken: container.accessToken || '',
    // 260807: 이름 스텝 스킵 판단. 네이티브는 웹과 달리 닉네임 폴백이 없고 실명 전용 필드
    //   (Android kakaoAccount.name / naver profile.name)만 넘기므로, 값이 있으면 곧 실명이다.
    //   ⚠️ 네이티브가 닉네임을 넣는 순간 이 전제가 깨진다 — 그쪽을 바꿀 땐 여기도 같이 볼 것.
    isRealName: !isEmpty(container.name),
    // 260807: 네이티브가 생년월일을 실어주면 프리필(현재 미전달 → '' → 사용자가 직접 입력).
    birthDate: container.birthDate || ''
  };

  const movePath = store.getters['layout/getLoginMovePath'];

  if (await store.dispatch('user/signIn', userData)) {
    if (movePath) {
      store.commit('layout/setLoginMovePath');
      return await router.replace(movePath);
    } else {
      return await router.replace('/');
    }
  } else {
    // 260812: 그 소셜의 본인확인 번호가 이미 다른 경로로 가입돼 있으면 가입 화면으로 보내지 않는다.
    //   앱은 소셜 로그인을 signIn 화면에서만 시작하므로 라우팅 없이 여기서 바로 안내한다
    //   (router.replace('/signin')은 이미 그 화면이라 재mount가 안 돼 모달이 뜨지 않는다).
    const blocked = consumeSocialJoinBlock();
    if (blocked) {
      showSocialJoinBlockedModal(blocked, nativeSnsLogin);
      return;
    }
    userData.code = '+82';
    store.commit('user/setSignUp', userData);
    console.log('콜백 스테이트 저장', store.getters['user/getSignUp']);
    store.commit('user/setIsSns', true);
    await router.push('/signup');
  }
  // store.commit('user/setUserData', userData);
};

let callbackScreenOnFunction;
window.callbackScreenOn = () => {
  if (callbackScreenOnFunction) {
    callbackScreenOnFunction();
  }
};
let callbackScreenOffFunction;
window.callbackScreenOff = () => {
  if (callbackScreenOffFunction) {
    callbackScreenOffFunction();
  }
};

window.onDynamicLink = async (dynamicLinkValue = '') => {
  // 260813 Play install referrer는 **앱을 지울 때까지 매 부팅 같은 값을 돌려준다**(구글 API 스펙).
  //   네이티브(MainActivity→PlayInstallReferrerHandler)에 1회 소비 마커가 없어, 정품등록 이월
  //   (/more/qr-genuine?code=)이 앱을 켤 때마다 재생됐다 — 교회처럼 사업자번호가 없는 업체는
  //   licensePending이 영원히 참이라 "앱 키면 무조건 사업자등록번호 페이지"(260813 유저 실측).
  //   한 번 소비한 QR 이월 값은 localStorage(부팅을 넘어 산다)로 기억하고 버린다.
  //   ⚠️QR 이월 경로에만 건다 — 초대장(smile) 등 다른 링크는 같은 값 재진입이 정상 동선이다.
  if (dynamicLinkValue.startsWith('/more/qr-genuine')) {
    try {
      const KEY = 'jump.qr.dynamicLinkConsumed';
      if (localStorage.getItem(KEY) === dynamicLinkValue) return;
      localStorage.setItem(KEY, dynamicLinkValue);
    } catch (_) { /* storage 차단 시 기존 동작(막지는 못해도 기능은 산다) */ }
  }
  const user = store.getters['user/getUserData'];
  if (dynamicLinkValue.includes('smile/event/info/hall/')) {
    if (!isEmpty(user.userNo)) {
      await router.push(dynamicLinkValue);
    } else {
      store.commit('layout/setLoginMovePath', dynamicLinkValue);
      await router.push('/signin');
    }
    return;
  }
  if (!isEmpty(dynamicLinkValue)) {
    store.commit('layout/setInitMovePath', dynamicLinkValue);
  }
};

export const connectedSocket = (screenOnFunction, screenOffFunction) => {
  callbackScreenOnFunction = screenOnFunction;
  callbackScreenOffFunction = screenOffFunction;
};
export const closeSocket = () => {
  callbackScreenOnFunction = undefined;
  callbackScreenOffFunction = undefined;
};

window.inAppPurchase = async (code, receipt) => {
  const userData = store.getters['user/getUserData'];
  const purchase = store.getters['user/getPurchase'];

  // 디바이스 연결 성공시
  const responseData = JSON.parse(code);
  console.log('네이티브 인앱 구매 응답', responseData);

  let os = 'ANDROID';
  if (isIPhone() || isIPad()) os = 'IOS';

  console.log('OS :: ', os);

  store.dispatch('layout/updateIsLoading', { isLoading: false });
  if (responseData.code == 1) {
    // 구매후 데이터베이스에 저장하는것 같음.
    const payload = {
      userNo: userData.userNo,
      os: os,
      category: purchase.category,
      productNo: purchase.productNo,
      price: purchase.price,
      itemType: purchase.productCode,
      useTargetNo: purchase.useTargetNo,
      productCode: purchase.productCode,
      purchaseToken: responseData.purchaseToken,
      orderId: responseData.orderId,
      productId: responseData.productId,
      receipt: receipt
    };

    console.log('구매 정보', payload);
    const response = await ServiceExec.post(common.inAppPurchase, payload);
    console.log('구매 결과', response);

    // 구매 성공시
    if (response.status === ServiceExec.status.OK) {
      showTextModal('구매가 완료되었습니다.', '확인');

      store.dispatch('payment/fetchCanSuperChat');

      const callBack = store.getters['user/getPurchaseCallBack'];
      const productByMove = store.getters['layout/getProductBuyMove'];
      console.log('인앱 콜백 : ', callBack);
      if (callBack) {
        callBack();
        store.commit('user/setPurchaseCallBack', '');
      }
      if (productByMove) {
        setTimeout(() => {
          store.commit('layout/setProductBuyMove', false);
          router.go(-1);
        }, 1000);
      }
    } else {
      console.error('구매 실패', response.data);
    }
  }
};
